/**
 * Tiny logger that suppresses output in production builds.
 *
 * All non-development `console.debug` / `console.log` chatter is stripped
 * automatically: React's production build sets `NODE_ENV=production` so the
 * guard collapses to `false` and the calls become dead code that the minifier
 * removes. In development we still see the trace for debugging.
 *
 * Use `warn()` / `error()` for problems that must surface even in production —
 * they always emit, but do not include sensitive payloads.
 */
const isDev = typeof process !== "undefined" && process.env && process.env.NODE_ENV !== "production";

export const debug = (...args) => { if (isDev) console.debug(...args); };
export const log   = (...args) => { if (isDev) console.log(...args); };
export const warn  = (...args) => console.warn(...args);
export const error = (...args) => console.error(...args);
